"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MonumentTabs = require("./MonumentTabs");
Object.keys(_MonumentTabs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MonumentTabs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MonumentTabs[key];
    }
  });
});
var _TabPane = require("./TabPane");
Object.keys(_TabPane).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TabPane[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TabPane[key];
    }
  });
});